import styled from 'styled-components';
import { heightWithoutToolbar } from '../../../common/services/screen';

export const Content = styled.div`
  width: 100%;
  height: ${heightWithoutToolbar};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
